import type { PortableTextBlock } from 'sanity';
import {
  BRAND_PLACEHOLDER,
  CITY_PLACEHOLDER,
  type BrandProfileSanityDoc,
} from '~/app/types/brandProfiles';
import { substituteVariablesInPortableBlocks } from '~/app/utils/portableTextSubstitutions';

export interface BrandListHeroDescriptionParams {
  brandProfileSanity?: BrandProfileSanityDoc | null;
  brandName: string;
}

export interface CityHeroDescriptionParams {
  brandProfileSanity?: BrandProfileSanityDoc | null;
  brandName: string;
  cityName: string;
}

function applyBrandPlaceholders(blocks: PortableTextBlock[], brandName: string): PortableTextBlock[] {
  return substituteVariablesInPortableBlocks(blocks, { [BRAND_PLACEHOLDER]: brandName });
}

export function getBrandListHeroDescription(params: BrandListHeroDescriptionParams): PortableTextBlock[] {
  const { brandProfileSanity: sanity, brandName } = params;
  const fromDoc = sanity?.description;
  const sharedBrandDefault = sanity?.brandProfileDefaultTexts?.brandDefaultDescription;
  const blocks = fromDoc || sharedBrandDefault || [];
  const substituteBrand = !fromDoc && (sharedBrandDefault?.length ?? 0) > 0;
  return substituteBrand ? applyBrandPlaceholders(blocks, brandName) : blocks;
}

export function getCityHeroDescription(params: CityHeroDescriptionParams): PortableTextBlock[] {
  const { brandProfileSanity: sanity, brandName, cityName } = params;
  return substituteVariablesInPortableBlocks(sanity?.brandProfileDefaultTexts?.cityDefaultDescription ?? [], {
    [BRAND_PLACEHOLDER]: brandName,
    [CITY_PLACEHOLDER]: cityName,
  });
}
